// src/app/contexts/UserContext.js
import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if localStorage is available
    if (typeof localStorage !== 'undefined') {
      const userString = localStorage.getItem('user');
      if (userString) {
        try {
          const userData = JSON.parse(userString);
          setUser(userData);
        } catch (e) {
          console.error('Error parsing user data from localStorage:', e);
          // Optionally, clear invalid data from localStorage
          localStorage.removeItem('user');
        }
      }
    }
  }, []);

  const saveUser = (userData) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('user', JSON.stringify(userData)); // Persist user data
    }
    setUser(userData);
  };

  const clearUser = () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('user');
    }
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, saveUser, clearUser }}>
      {children}
    </UserContext.Provider>
  );
};
